import { SvgIcon, SvgIconProps } from '@mui/material'

function MotherIcon(props: SvgIconProps) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 161.84 150.83"
      sx={{ p: '2px', mb: '2px', ...props.sx }}
    >
      <path d="M72.25,61.34c-.06-.05-.13-.09-.19-.13L20.91,3.08C12.31-3.4,0,2.73,0,13.5v124.28c0,7.21,5.84,13.05,13.05,13.05h7.09l61.54-78.74-9.42-10.74Z" />
      <path d="M117.6,127.7h-28.86c-.92,0-1.42-1.07-.81-1.75l20.1-22.44c.35-.4.36-.99,0-1.39l-14.49-16.52-50.79,65.22h67.03l8.81-21.68c.28-.69-.24-1.45-1-1.45Z" />
      <path d="M141.07,2.55l-50.68,55.73,38.22,41.91c.37.4.36,1.01,0,1.41l-9.92,10.71c-.63.68-.13,1.77.81,1.76l29.01-.3c.94,0,1.44,1.09.8,1.77l-32.96,35.28h32.45c7.21,0,13.05-5.84,13.05-13.05V13.07c0-10.69-12.15-16.85-20.77-10.52Z" />
    </SvgIcon>
  )
}

export default MotherIcon
